const formatKm = (m: server.dto.Distance, decimals: number): string => {
  if (!decimals) decimals = 0;

  const rounded = m.meter / 1000;
  return `${rounded.toFixed(decimals)} km`;
};

export {
  formatKm
};
